import styled from 'styled-components';
import { Typography } from '../../../ui/Typography';

export const ValidationCounterText = styled(Typography).attrs({
  tag: 'body_2'
})`
  display: inline-block;
  color: ${({ theme: { colors } }) => colors.text.secondary};
  margin-top: ${({ $margin }) => $margin || 10}px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    margin-top: ${({ $margin }) => $margin || 20}px;
  }
`;
